import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import "./assets/sass/style.scss";
import "bootstrap/dist/js/bootstrap.min.js"
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'src/locales/i18n';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <App id="app" />
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.info))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();